import { PATH_CONFIG } from "./paths.config";
import { ROUTES_CONFIG } from "./route.config";

export const environment = {
    idCentroComercial:32,
    centroComercial:'CRMESTACIONII',
    routeLogin:'./dashboard/almacen/',
    routeLoginClient:'./dashboard/facturas/register',
    imageIcon:'https://granestacion2.com.co/wp-content/uploads/2023/05/LOGO-GEII.png',
    jumpCube:false,
    paths:PATH_CONFIG,
    ...ROUTES_CONFIG,     
};
